import React from 'react';
import { Grid } from '@mui/system';

function ContactInfo({ contactInfo }) {
  return (
    <Grid
      container
      className="contact-info-section"
      sx={{ justifyContent: 'space-between' }}
      rowSpacing={{ xs: 5, sm: 2, md: 1 }}
      columnSpacing={{ xs: 5, sm: 2, md: 1 }}
    >
      <Grid
        size={{ xs: 12, sm: 5 }}
      >
        <h1 className="title">{contactInfo?.title}</h1>
        <h5 className="subTitle">{contactInfo?.subTitle}</h5>
      </Grid>
      <Grid size={{ xs: 12, sm: 1, md: 1 }} sx={{ display: { sm: 'none' } }} />

      {contactInfo?.contactBox?.map((item) => (
        <Grid size={{ xs: 6, sm: 3 }} key={item?.contactType || item?.id}>
          <div className="contact-box">
            <div className="box-title">{item?.contactType}</div>
            <div className="line" />
            {item?.contactSource && item?.contactSource.includes('@') ? (
              <div>
                <a className="box-subtitle" style={{ textDecoration: 'none' }} href={`mailto:${item?.contactSource}`}>{item?.contactSource}</a>
              </div>
            ) : (
              <div className="box-subtitle">{item?.contactSource}</div>
            )}
            <div className="timing" dangerouslySetInnerHTML={{ __html: item?.timing }} />
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default ContactInfo;
